import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Dropdown, Row, Col, Container, Button } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation } from "swiper";
import "swiper/swiper-bundle.css";
import {GetContentThunk } from "../../../store/redux/SLICE/auth/Content";
import { useDispatch,useSelector } from "react-redux";
import { BASE_URL } from '../../../BaseUrl';
import axios from 'axios';
import { TMDB_CONFIG } from '../../../config/tmdb';
import '../../../assets/css/home-section-sizing.css';
import { CompactWatchlistButtons } from "../../../components/WatchlistButtons";



//img
import banner from "../../../assets/images/movie-banner/1.jpg";
import banner2 from "../../../assets/images/movie-banner/2.jpg";
import banner3 from "../../../assets/images/movie-banner/3.jpg";
import img1 from "../../../assets/images/upcoming/01.jpg";
import img2 from "../../../assets/images/upcoming/02.jpg";
import img3 from "../../../assets/images/upcoming/03.jpg";
import img4 from "../../../assets/images/upcoming/04.jpg";
import img5 from "../../../assets/images/upcoming/05.jpg";
import movie1 from "../../../assets/images/movies/01.jpg";
import movie2 from "../../../assets/images/movies/02.jpg";
import movie3 from "../../../assets/images/movies/03.jpg";
import movie4 from "../../../assets/images/movies/04.jpg";
import movie5 from "../../../assets/images/movies/05.jpg";
import movie6 from "../../../assets/images/movies/06.jpg";
import movie7 from "../../../assets/images/movies/07.jpg";
import movie8 from "../../../assets/images/movies/08.jpg";
import movie9 from "../../../assets/images/movies/09.jpg";
import movie10 from "../../../assets/images/movies/10.jpg";

// Top rating images
import top1 from "../../../assets/images/Top-ratings/top-1.png";
import top2 from "../../../assets/images/Top-ratings/top-2.png";
import top3 from "../../../assets/images/Top-ratings/top-3.png";
import top4 from "../../../assets/images/Top-ratings/top-4.png";
import top5 from "../../../assets/images/Top-ratings/top-5.png";
import top6 from "../../../assets/images/Top-ratings/top-6.png";
import top7 from "../../../assets/images/Top-ratings/top-7.png";
import top8 from "../../../assets/images/Top-ratings/top-8.png";
import top9 from "../../../assets/images/Top-ratings/top-9.png";
import top10 from "../../../assets/images/Top-ratings/top-10.png";

import { familiarFavorites } from "../dummyData/homeDummyData";
import { Top10ShowsInUS, newOnCopepod } from "../dummyData/newAndPopularData";
import { toast } from "react-toastify";

const imag1 =  <svg id="rank-1" width="100%" height="100%" viewBox="-20 0 70 154" class="svg-icon svg-icon-rank-1 top-10-rank"><path stroke="#595959" stroke-linejoin="square" stroke-width="4" d="M35.377 152H72V2.538L2 19.362v30.341l33.377-8.459V152z"></path></svg>

// Top rating images mapping
const topRatingImages = {
  1: top1,
  2: top2,
  3: top3,
  4: top4,
  5: top5,
  6: top6,
  7: top7,
  8: top8,
  9: top9,
  10: top10
};

// install Swiper modules
SwiperCore.use([Navigation]);

const NewAndPopular = ({itemName}) => {

  // State for TMDB trending movies
  const [trendingMoviesData, setTrendingMoviesData] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // State for TMDB upcoming movies
  const [upcomingState, setUpcomingState] = useState({
    movies: [],
    loading: false,
    error: null
  });

  // State for TMDB top-rated TV shows
  const [topRatedTVShows, setTopRatedTVShows] = useState({
    shows: [],
    loading: false,
    error: null
  });

  // State for TMDB top-rated movies
  const [topRatedMovies, setTopRatedMovies] = useState({
    movies: [],
    loading: false,
    error: null
  });

  const handleAddToWatchList = () => {
    const existingWatchList = JSON.parse(localStorage.getItem('watchlist')) || [];
    existingWatchList.push(itemName);
    localStorage.setItem('watchlist', JSON.stringify(existingWatchList));
    toast.success(`Added "${itemName}" to watch list successfully`);
  };

  const handleAddClick = (Data) => {
    toast.success(Data, {
      position: "top-right",
      autoClose: 3000, 
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const copyURL = () => {
    const url = window.location.href;
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = url;
    tempInput.select();
    document.execCommand("copy");
    document.body.removeChild(tempInput);

    toast.success("URL copied to clipboard: " + url)
   
  };

  const handleLinkClick = () => {
    window.scrollTo(0, 0); 
  };

  // Simple test function to verify movies API
  const testMoviesAPI = async () => {
    try {
      const response = await axios.get('https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1', {
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      });
      console.log("🎬 API Test Success:", response.data.results.length, "movies found");
      console.log("🎬 First movie:", response.data.results[0].title);
      alert(`✅ API Working! Found ${response.data.results.length} movies. First: ${response.data.results[0].title}`);
    } catch (error) {
      console.error("🎬 API Test Failed:", error);
      alert(`❌ API Error: ${error.message}`);
    }
  };

  const dispatch = useDispatch();

  // TMDB Trending Movies API Service
  const fetchTrendingMovies = async () => {
    try {
      // Check if JWT token is configured
      if (TMDB_CONFIG.JWT_TOKEN === 'YOUR_TMDB_JWT_TOKEN') {
        throw new Error('TMDB JWT token not configured. Please add your JWT token to the environment variables or config file.');
      }

      const url = `${TMDB_CONFIG.BASE_URL}/trending/movie/day?language=en-US`;

      const options = {
        method: 'GET',
        url: url,
        headers: {
          accept: 'application/json',
          Authorization: `Bearer ${TMDB_CONFIG.JWT_TOKEN}`
        }
      };

      const response = await axios.request(options);
      return response.data;
    } catch (error) {
      console.error('Error fetching TMDB trending movies:', error);
      throw error;
    }
  };

  // TMDB Upcoming Movies API Service
  const fetchUpcomingMovies = async () => {
    setUpcomingState(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      const transformedData = response.data.results.map(movie => ({
        id: movie.id,
        title: movie.title,
        imageUrl: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        ageRating: movie.adult ? '18+' : '13+',
        duration: '2h 30m'
      }));

      setUpcomingState({ 
        movies: transformedData, 
        loading: false, 
        error: null 
      });
    } catch (error) {
      setUpcomingState(prev => ({
        ...prev,
        loading: false,
        error: error.message || 'Failed to fetch upcoming movies'
      }));
      console.error('Error fetching upcoming movies:', error);
    }
  };

  // Transform TMDB trending data to match original component structure
  const transformTrendingMoviesData = (trendingData) => {
    return trendingData.results.map(item => {
      console.log("Processing movie item:", item);
      console.log("Poster path:", item.poster_path);

      return {
        _id: item.id.toString(),
        title: item.title,
        contentName: item.title,
        description: item.overview,
        // Use original structure for images
        imageUrl: item.poster_path ? `https://image.tmdb.org/t/p/w500${item.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        topImg: `https://via.placeholder.com/50x50/333/fff?text=${item.id}`, // For numbered badges
        // Original structure fields
        ageRating: item.adult ? '18+' : '13+',
        duration: '2h 30m', // Default duration for movies
        // Additional TMDB fields
        release_date: item.release_date,
        vote_average: item.vote_average,
        vote_count: item.vote_count,
        adult: item.adult,
        genre_ids: item.genre_ids,
        original_language: item.original_language,
        original_title: item.original_title,
        popularity: item.popularity,
        video: item.video,
        media_type: 'movie'
      };
    });
  };

  // Fetch TMDB trending movies data
  const fetchTrendingMoviesData = async () => {
    setTrendingMoviesData(prev => ({ ...prev, loading: true, error: null }));
    try {
      const data = await fetchTrendingMovies();
      console.log("Raw TMDB trending movies data:", data);

      const transformedData = transformTrendingMoviesData(data);
      console.log("Transformed trending movies data:", transformedData);

      setTrendingMoviesData({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Trending movies data fetched successfully:", transformedData);
    } catch (error) {
      setTrendingMoviesData(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch trending movies data"
      }));
      console.error("Failed to fetch TMDB trending movies data:", error);
    }
  };

  // Fetch TMDB top-rated TV shows data
  const fetchTopRatedTVShows = async () => {
    setTopRatedTVShows(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/tv/top_rated?language=en-US&page=1',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      console.log("Raw TMDB top-rated TV shows data:", response.data);

      // Transform data to match the expected structure with top 10 ranking
      const transformedData = response.data.results.slice(0, 10).map((show, index) => ({
        id: show.id,
        title: show.name,
        imageUrl: show.poster_path ? `https://image.tmdb.org/t/p/w500${show.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        topImg: topRatingImages[index + 1],
        ageRating: '13+',
        duration: 'Series',
        vote_average: show.vote_average,
        vote_count: show.vote_count,
        first_air_date: show.first_air_date,
        overview: show.overview,
        genre_ids: show.genre_ids,
        popularity: show.popularity,
        original_language: show.original_language,
        original_name: show.original_name,
        media_type: 'tv'
      }));

      console.log("Transformed top-rated TV shows data:", transformedData);

      setTopRatedTVShows({
        shows: transformedData,
        loading: false,
        error: null
      });
      console.log("TMDB Top-rated TV shows data fetched successfully:", transformedData);
    } catch (error) {
      setTopRatedTVShows(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch top-rated TV shows data"
      }));
      console.error("Failed to fetch TMDB top-rated TV shows data:", error);
    }
  };

  // Fetch TMDB top-rated movies data
  const fetchTopRatedMovies = async () => {
    console.log("🎬 Starting to fetch top-rated movies...");
    setTopRatedMovies(prev => ({ ...prev, loading: true, error: null }));
    try {
      const options = {
        method: 'GET',
        url: 'https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1',
        headers: {
          accept: 'application/json',
          Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjNmU5MzM1Yjg5Y2E3NWE3MGJjY2UxYzcyYmZkMDQ4ZCIsInN1YiI6IjYzYmVkN2FiODU4Njc4MDBmMDhjZjI3NiIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.sQHes_rn51wewxY_7nZLxGssnd67J8ieiLOIo2Bg_FI'
        }
      };

      const response = await axios.request(options);
      console.log("Raw TMDB top-rated Movies data:", response.data);
      // Transform data to match the expected structure with top 10 ranking
      
      const transformedData = response.data.results.slice(0, 10).map((movie, index) => ({
        id: movie.id,
        title: movie.title,
        imageUrl: movie.poster_path ? `https://image.tmdb.org/t/p/w500${movie.poster_path}` : 'https://via.placeholder.com/300x450/333/fff?text=No+Image',
        topImg: topRatingImages[index + 1],
        ageRating: movie.adult ? '18+' : '13+',
        duration: '2h 30m',
        vote_average: movie.vote_average,
        vote_count: movie.vote_count,
        release_date: movie.release_date,
        overview: movie.overview,
        genre_ids: movie.genre_ids,
        popularity: movie.popularity,
        original_language: movie.original_language,
        original_title: movie.original_title,
        media_type: 'movie'
      }));

      console.log("🎬 Transformed top-rated movies data:", transformedData);
      console.log("🎬 Number of transformed movies:", transformedData.length);
      console.log("🎬 First movie:", transformedData[0]);

      console.log("🎬 Setting movies state...");
      setTopRatedMovies({
        movies: transformedData,
        loading: false,
        error: null
      });
      console.log("🎬 TMDB Top-rated movies data fetched successfully!");
    } catch (error) {
      setTopRatedMovies(prev => ({
        ...prev,
        loading: false,
        error: error.message || "Failed to fetch top-rated movies data"
      }));
      console.error("Failed to fetch TMDB top-rated movies data:", error);
    }
  };
 
  
useEffect(() => {
  dispatch(GetContentThunk());
  fetchTrendingMoviesData();
  fetchUpcomingMovies();
  fetchTopRatedTVShows();
  fetchTopRatedMovies();
}, [dispatch]);


const store = useSelector((state)=>state);
console.log(store,"Sub User store")

const moviesContent=store && store?.contents?.contents
console.log(moviesContent,"moviesContent User store")

// Debug movies state

if (topRatedMovies.movies.length > 0) {
  console.log("🎬 First movie data:", topRatedMovies.movies[0]);
  console.log("🎬 First movie imageUrl:", topRatedMovies.movies[0].imageUrl);
  console.log("🎬 First movie topImg:", topRatedMovies.movies[0].topImg);
}

  return (
    <>
    
     
      <div className="main-content">
      {/* New on copepod */}
      <section id="iq-new-Popular">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">New on copepod</h4>
                  <Link className="iq-view-all" to="/view-all" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div id="prev-new-popular" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next-new-popular" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    navigation={{
                      prevEl: "#prev-new-popular",
                      nextEl: "#next-new-popular",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {trendingMoviesData.loading ? (
                      <div className="col-12 d-flex justify-content-center align-items-center" >
                      <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p className="text-white mt-2">Loading upcoming movies...</p>
                      </div>
                    </div>
                    ) : trendingMoviesData.error ? (
                      <div className="col-12 text-center">
                        <h3 className="text-white">Error Loading Trending Movies</h3>
                        <p className="text-white-50">{trendingMoviesData.error}</p>
                        <button
                          className="btn btn-primary mt-3"
                          onClick={fetchTrendingMoviesData}
                        >
                          Retry
                        </button>
                      </div>
                    ) : trendingMoviesData.movies && trendingMoviesData.movies.length > 0 ? (
                      trendingMoviesData.movies.slice(0, 10).map((item, index) => (
                        <SwiperSlide as="li" key={item._id}>
                          <div className=" block-images position-relative">
                            <div className="img-box">
                              <img
                                src={item.imageUrl}
                                className="img-fluid"
                                style={{height: '200px', width: '100%', objectFit: 'cover'}}
                                alt={item.title}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image';
                                }}
                              />
                            </div>
                            <div className="block-description">
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${item._id}`}>{item.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item.ageRating}
                                </div>
                                <span className="text-white">
                                  {item.duration}
                                </span>
                              </div>
                              <div className="hover-buttons">
                                <Link
                                  to={`/movie-details/${item._id}`}
                                  role="button"
                                  className="btn btn-hover iq-button"
                                >
                                  <i
                                    className="fa fa-play mr-1"
                                    aria-hidden="true"
                                  ></i>
                                  Play Now
                                </Link>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a
                                        href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-facebook-fill"></i>
                                      </a>
                                      <a
                                        href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="share-ico"
                                        tabIndex="0"
                                      >
                                        <i className="ri-twitter-fill"></i>
                                      </a>
                                      <a
                                         onClick={copyURL}
                                        data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                        className="share-ico iq-copy-link"
                                        tabIndex="0"
                                      >
                                        <i className="ri-links-fill"></i>
                                      </a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No trending movies available</p>
                      </div>
                    )
                  }
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/* Top 10 TV Shows */}
        <section id="iq-top-tv-show">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">Top 10 TV Shows</h4>
                  <Link className="iq-view-all" to="/view-all" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  {topRatedTVShows.loading && (
                    <div className="text-center p-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2">Loading top-rated TV shows...</p>
                    </div>
                  )}
                  {topRatedTVShows.error && (
                    <div className="alert alert-warning" role="alert">
                      <strong>Warning:</strong> {topRatedTVShows.error}
                      <br />
                      <small>Showing default data instead.</small>
                    </div>
                  )}
                  <div id="prev-top-tv-show" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next-top-tv-show" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    navigation={{
                      prevEl: "#prev-top-tv-show",
                      nextEl: "#next-top-tv-show",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {(topRatedTVShows.shows.length > 0 ? topRatedTVShows.shows : Top10ShowsInUS).map((item, index) => (
                      <SwiperSlide as="li" key={item.id || index}>
                        <div className=" block-images position-relative">
                          <div className="img-box"  >
                            <img
                              src={item?.topImg}
                              className="img-fluid img-top-10-number"
                              alt=""
                            />
                            <img
                              src={item?.imageUrl}
                              className="img-fluid img-top-10-image"
                              alt=""
                            />
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                              <Link to={`/show-details/${item?.id}`}>{item?.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                              <div className="badge badge-secondary p-1 mr-2">
                                {item?.ageRating}
                              </div>
                              <span className="text-white">
                                {item?.duration}
                              </span>
                              {item?.vote_average && (
                                <span className="text-warning ml-2">
                                  ⭐ {item.vote_average.toFixed(1)}
                                </span>
                              )}
                            </div>
                            <div className="hover-buttons">
                              <Link
                                to={`/show-details/${item?.id}`}
                                role="button"
                                className="btn btn-hover iq-button"
                              >
                                <i
                                  className="fa fa-play mr-1"
                                  aria-hidden="true"
                                ></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                      href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                       onClick={copyURL}
                                      data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <CompactWatchlistButtons item={{
                                id: parseInt(item._id),
                                title: item.title,
                                type: 'movie',
                                poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                imgSrc: item.imageUrl,
                                vote_average: item.vote_average,
                                release_date: item.release_date,
                                overview: item.description,
                                adult: item.adult
                              }} />
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

          {/* Comming next week */}
          <section id="iq-comming-next-week">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">Comming Next week</h4>
                  <Link className="iq-view-all" to="/view-all" onClick={handleLinkClick}>
                    View All
                  </Link>
                </div>
                <div id="favorites-contens">
                  <div id="prev-comming-next-week" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next-comming-next-week" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    navigation={{
                      prevEl: "#prev-comming-next-week",
                      nextEl: "#next-comming-next-week",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                    {upcomingState?.loading ? (
                      <div className="col-12 d-flex justify-content-center align-items-center" >
                        <div className="text-center">
                          <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                          </div>
                          <p className="text-white mt-2">Loading upcoming movies...</p>
                        </div>
                      </div>
                    ) : upcomingState?.error ? (
                      <div className="col-12 text-center">
                        <p className="text-white">{upcomingState.error}</p>
                        <button className="btn btn-primary mt-2" onClick={fetchUpcomingMovies}>Retry</button>
                      </div>
                    ) : upcomingState?.movies?.length ? (
                      upcomingState.movies.slice(0, 10).map((item, index) => (
                        <SwiperSlide as="li" key={item.id || index}>
                          <div className=" block-images position-relative" >
                            <div className="img-box" >
                              <img
                                src={item?.imageUrl}
                                className="img-fluid "
                                style={{height: '200px', width: '100%', objectFit: 'cover'}}
                                alt={item?.title || ''}
                                onError={(e) => {
                                  e.target.src = 'https://via.placeholder.com/300x450/333/fff?text=No+Image';
                                }}
                                
                              />
                            </div>
                            <div className="block-description" >
                              <h6 className="iq-title">
                                <Link to={`/movie-details/${item.id}`}>{item?.title}</Link>
                              </h6>
                              <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                                <div className="badge badge-secondary p-1 mr-2">
                                  {item?.ageRating}
                                </div>
                                <span className="text-white">
                                  {item?.duration}
                                </span>
                              </div>
                            </div>
                            <div className="block-social-info">
                              <ul className="list-inline p-0 m-0 music-play-lists">
                                <li className="share">
                                  <span>
                                    <i className="ri-share-fill"></i>
                                  </span>
                                  <div className="share-box">
                                    <div className="d-flex align-items-center">
                                      <a href={`https://www.facebook.com/sharer?u=${window.location.href}`} target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0"><i className="ri-facebook-fill"></i></a>
                                      <a href={`https://twitter.com/intent/tweet?text=${encodeURIComponent('Check this movie: ' + (item?.title || ''))}`} target="_blank" rel="noopener noreferrer" className="share-ico" tabIndex="0"><i className="ri-twitter-fill"></i></a>
                                      <a onClick={copyURL} className="share-ico iq-copy-link" tabIndex="0"><i className="ri-links-fill"></i></a>
                                    </div>
                                  </div>
                                </li>
                                <CompactWatchlistButtons item={{
                                  id: parseInt(item._id),
                                  title: item.title,
                                  type: 'movie',
                                  poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                  imgSrc: item.imageUrl,
                                  vote_average: item.vote_average,
                                  release_date: item.release_date,
                                  overview: item.description,
                                  adult: item.adult
                                }} />
                              </ul>
                            </div>
                          </div>
                        </SwiperSlide>
                      ))
                    ) : (
                      <div className="col-12 text-center">
                        <p className="text-white">No upcoming movies available</p>
                      </div>
                    )}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

          {/* Top 10 movie in US */}
      <section id="iq-top-movies">
          <Container fluid>
            <Row>
              <Col sm="12" className="overflow-hidden">
                <div className="d-flex align-items-center justify-content-between ">
                  <h4 className="main-title mb-3">Top 10 Movies</h4>
                 
                    <Link className="iq-view-all" to="/view-all" onClick={handleLinkClick}>
                      View All
                    </Link>
                 
                </div>
                <div id="favorites-contens">
                  {topRatedMovies.loading && (
                    <div className="text-center p-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="mt-2">Loading top-rated movies...</p>
                    </div>
                  )}
                  {topRatedMovies.error && (
                    <div className="alert alert-warning" role="alert">
                      <strong>Warning:</strong> {topRatedMovies.error}
                      <br />
                      <small>Showing default data instead.</small>
                    </div>
                  )}
                 
                  <div id="prev-top-movies" className="swiper-button swiper-button-prev">
                    <i className="fa fa-chevron-left"></i>
                  </div>
                  <div id="next-top-movies" className="swiper-button swiper-button-next">
                    <i className="fa fa-chevron-right"></i>
                  </div>
                  <Swiper
                    breakpoints={{
                      320: { slidesPerView: 1 },
                      550: { slidesPerView: 2 },
                      991: { slidesPerView: 3 },
                      1400: { slidesPerView: 4 },
                    }}
                    navigation={{
                      prevEl: "#prev-top-movies",
                      nextEl: "#next-top-movies",
                    }}
                    loop={true}
                    slidesPerView={4}
                    spaceBetween={20}
                    as="ul"
                    className="favorites-slider list-inline row p-0 m-0 iq-rtl-direction"
                  >
                     {(topRatedMovies.movies.length > 0 ? topRatedMovies.movies : Top10ShowsInUS).map((item, index) => (
                      <SwiperSlide as="li" key={item?.id || index}>
                        <div className=" block-images position-relative">
                          <div className="img-box">
                          <img
                              src={item?.topImg}
                              className="img-fluid img-top-10-number"
                              alt=""
                            />
                            <img
                              src={item?.imageUrl}
                              className="img-fluid img-top-10-image"
                              alt=""
                            />
                              
                          </div>
                          <div className="block-description">
                            <h6 className="iq-title">
                              <Link to={`/show-details/${item?.id}`}>{item?.title}</Link>
                            </h6>
                            <div className="movie-time d-flex align-items-center my-2 iq-ltr-direction">
                              <div className="badge badge-secondary p-1 mr-2">
                                {item?.ageRating}
                              </div>
                              <span className="text-white">
                                {item?.duration}
                              </span>
                              {item?.vote_average && (
                                <span className="text-warning ml-2">
                                  ⭐ {item.vote_average.toFixed(1)}
                                </span>
                              )}
                            </div>
                            <div className="hover-buttons">
                              <Link
                                to={`/show-details/${item?.id}`}
                                role="button"
                                className="btn btn-hover iq-button"
                              >
                                <i
                                  className="fa fa-play mr-1"
                                  aria-hidden="true"
                                ></i>
                                Play Now
                              </Link>
                            </div>
                          </div>
                          <div className="block-social-info">
                            <ul className="list-inline p-0 m-0 music-play-lists">
                              <li className="share">
                                <span>
                                  <i className="ri-share-fill"></i>
                                </span>
                                <div className="share-box">
                                  <div className="d-flex align-items-center">
                                    <a
                                      href="https://www.facebook.com/sharer?u=https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-facebook-fill"></i>
                                    </a>
                                    <a
                                      href="https://twitter.com/intent/tweet?text=Currentlyreading"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="share-ico"
                                      tabIndex="0"
                                    >
                                      <i className="ri-twitter-fill"></i>
                                    </a>
                                    <a
                                       onClick={copyURL}
                                      data-link="https://iqonic.design/wp-themes/copepod_wp/movie/shadow/"
                                      className="share-ico iq-copy-link"
                                      tabIndex="0"
                                    >
                                      <i className="ri-links-fill"></i>
                                    </a>
                                  </div>
                                </div>
                              </li>
                              <CompactWatchlistButtons item={{
                                id: parseInt(item._id),
                                title: item.title,
                                type: 'movie',
                                poster_path: item.imageUrl?.includes('tmdb.org') ? item.imageUrl.split('/').pop() : null,
                                imgSrc: item.imageUrl,
                                vote_average: item.vote_average,
                                release_date: item.release_date,
                                overview: item.description,
                                adult: item.adult
                              }} />
                            </ul>
                          </div>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        
        
       

      </div>
    </>
  );
};
export default NewAndPopular;
